var utils = require('./utils.js');

module.exports = {
    submitMessage: function (sucCallback) {
        var data = {
            content: $('#message_form [name=content]').val(),
            name: $('#message_form [name=name]').val(),
            mobile: $('#message_form [name=phone]').val(),
            email: $('#message_form [name=email]').val(),
            address: $('#message_form [name=address]').val(),
            _csrf: $('[name=_csrf]').val()
        };
        if (data.content.replace(/\s/g, '') == '') {
            utils.alert('请输入留言内容');
            return;
        }
        if (data.mobile.replace(/\s/g, '') == '') {
            utils.alert('请输入电话');
            return;
        }

        $.ajax({
            url: '/site/board',
            beforeSend: function () {
                $('#submit_message').addClass('disabled').text('提交中');
            },
            type: 'POST',
            dataType: 'JSON',
            data: data,
            success: function (res) {
                // console.log(res.message)
                $('#submit_message').removeClass('disabled').text('提交');
                if (res.status == 1) {  //提交成功
                    $('#message_form input, #message_form textarea').val('');
                    if(typeof sucCallback == 'function') {
                        sucCallback();
                    } else {
                        utils.alert('提交成功！');
                    }
                } else {
                    utils.alert(res.message.join(','));
                }
            },
            fail: function () {
                $('#submit_message').removeClass('disabled').text('提交');
            }
        });
    }
}